var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.handleDrawer($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }